<template>
    <van-nav-bar title="账号详情" left-text="返回" :fixed=true :placeholder=true left-arrow @click-left="goBack" />
    <div class="content" v-if="datainfo != ''" >
      <div style="position:relative;background: #ffffff;border-radius: 10px;overflow: hidden;padding: 0px 0px 10px 0px;">
        <img src="https://oss.xuxug.com/static/images/288.jpg" alt="" class="goods_item_img" v-if="datainfo.img == ''">
        <img :src="datainfo.img" alt="" class="goods_item_img" v-else>
        <div class="goodsname">{{datainfo.title}}</div>
        <div style="display: grid;grid-template-columns: 1fr auto;">
          <div style="text-align: left;padding: 0px 10px;font-size: 22px;font-weight: 700;color: #e53e3e;">¥{{datainfo.shoujia}}</div>
          <div style="text-align: center;padding-right:20px;">
            <!-- <van-button round icon="share-o" type="default" size="small" @click="showShaixuan">分享</van-button> -->
          </div>
        </div>
        <div style="display: grid;grid-template-columns: 1fr 1fr;margin-top: 5px;">
          <div style="font-size: 14px;text-align: left;padding: 0px 10px;">
            <van-button size="small" style="height:30px;background: linear-gradient(18deg, #409c52, #59bc6d 97%);padding: 4px 8px;border-radius: 4px;font-size: 12px;color: #fff;">找回包赔</van-button>
          </div>
          <div>

          </div>
        </div>
        <div style="display: grid;grid-template-columns: 1fr 1fr;margin:20px 10px 0px 10px;height:30px;border-bottom: 0.5px solid #ebedf0;">
          <div style="color: #000000;font-size: 14px;text-align: left;">
            <span style="color: #718096;font-weight: 500;flex-shrink: 0;">账号编号：</span>{{datainfo.bianhao}}
          </div>
          <div style="color: #000000;font-size: 14px;text-align: left;">
            <span style="color: #718096;">能否排位：</span>{{datainfo.shifoupaiwei}}
          </div>
        </div>
        <div style="display: grid;grid-template-columns: 1fr 1fr;margin:10px 10px 0px 10px;height:30px;border-bottom: 0px solid #ebedf0;">
          <div style="color: #000000;font-size: 14px;text-align: left;">
            <span style="color: #718096;">信用等级：</span>{{datainfo.xinyongdengji}}
          </div>
          <div style="color: #000000;font-size: 14px;text-align: left;">
            <span style="color: #718096;">生存等级：</span>{{datainfo.shengcundengji}}
          </div>
        </div>
        
        <!-- <van-grid :column-num="5" :border="false" style="margin-top:10px;">
          <van-grid-item icon="cart" text="下单"></van-grid-item>
          <van-grid-item icon="underway" text="验号" />
          <van-grid-item icon="column" text="合同" />
          <van-grid-item icon="gold-coin" text="换绑" />
          <van-grid-item icon="checked" text="完成" />
        </van-grid> -->
      </div>
      <div style="position:relative;background: #ffffff;border-radius: 10px;margin-top:10px;overflow: hidden;padding: 20px 0px;">
          <div style="text-align: left;margin-left:10px;font-size:16px;display: flex;align-items: center;">
            <van-divider vertical :style="{ height: '15px', width: '3px', backgroundColor: '#1989fa'}" />商品描述
          </div>
          <van-divider style="margin:10px;"/>
          <van-text-ellipsis rows="5" :content="datainfo.miaoshu" style="text-align: left;padding:0px 10px;font-size:14px;"/>
          <!-- <div style="text-align: left;padding:0px 10px;font-size:14px;">{{datainfo.miaoshu}}</div> -->
      </div>
      <div style="position:relative;background: #ffffff;border-radius: 10px;margin-top:10px;overflow: hidden;padding: 20px 0px;">
          <div style="text-align: left;margin-left:10px;font-size:16px;display: flex;align-items: center;">
            <van-divider vertical :style="{ height: '15px', width: '3px', backgroundColor: '#1989fa'}" />商品详情
          </div>
          <van-divider style="margin:10px;"/>
          <div class="shangpinxiangqing" v-html="datainfo.xiangqing"></div>
      </div>
    </div>
    <van-tabbar style="display: grid;grid-template-columns: 1fr;margin-top: 5px;">
      <div style="padding: 0px 10px;">
        <van-button round type="primary" block @click="lianxikefu">联系客服</van-button>
      </div>
    </van-tabbar>
  </template>
  
  <script>
  import { showNotify } from 'vant';
  export default {
    data() {
      return {
        userinfo:this.$getLoginInfo(),
        datainfo: "",
        showKefu:false,
        url:"https://fzkf.xuxug.com/index/index/home?visiter_id=2&visiter_name=18713957304&avatar=&business_id=1&groupid=0&fenzhan=lisi",
        isTtSdkReady:false,
      }
    },
    mounted() {
      this.$emit('child-data', 'yincang');
      this.onMounted();
    },
    created() {
      var id = this.$route.query.id;
      this.getDataInfo(id);
    },
    methods: {
      goBack() {
        if (!this.canGoBack()) {
          this.$router.push({ name: 'Home' });
        }
        else
        {
          this.$router.back()
        }
      },
      maijiaweixin(){
        this.showKefu = true;
      },
      onMounted(){
        // 等待抖音 SDK 初始化完成
        if (window.tt?.miniprogram) {
          window.tt.miniprogram.ready(() => {
            this.isTtSdkReady = true;
            console.log('抖音 JSSDK 初始化完成');
          });
        }
      },
      lianxikefu(){
        console.log("111");
        if (!this.isTtSdkReady) {
          console.error('抖音 SDK 未初始化完成');
          return;
        }

        // 发送消息给小程序（指令标识为 openCustomerService）
        window.tt.miniprogram.postMessage({
          data: {
            action: 'openKefu' // 自定义指令，用于小程序识别
          }
        });
      },
      dakaikefu(){
        if(this.datainfo.kefu_url != "")
        {
          window.location.href = this.datainfo.kefu_url;
        }
      },
      canGoBack() {
        return window.history.length > 2;
      },
      async showShaixuan(){
        try {
          var currentUrl = window.location.href;
          await navigator.clipboard.writeText(currentUrl);
          showNotify({ type: 'success', message: '复制成功' });
        } catch (err) {
          console.error('复制失败', err);
          showNotify({ type: 'danger', message: '复制失败' });
        }
      },
      getDataInfo(id){
        this.$http.post('/api/Douyinapi/newGoodsDetails', {
          id:id,
        })
        .then(response => {
          
          if(response.data.code == "true")
          {
            this.datainfo = response.data.data;
            document.title = this.datainfo.title;
          }
        })
        .catch(error => {
          console.error('There was an error!', error); // 处理错误
        });
      },
      onSubmit(){
        if(this.userinfo == '')
        {
          this.$router.push({ path: '/login', query: { } })
        }
        else
        {
          console.log(this.userinfo);
        }
      },
    }
  }
  </script>
  
  <style scoped>
  .content {
    padding: 10px;
  }
  .goodsname{
      padding: 10px 10px;
      text-align: left;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 5; /* 限制文本为2行 */
      overflow: hidden;
      font-size: 18px;
      font-weight: 700;
      color: #2d3748;
      margin-bottom: 10px;
      line-height: 1.4;
      letter-spacing: -.5px;
    }
    .shangpinxiangqing{
      text-align: left;
      padding:0px 10px;
      font-size:14px;
    }
    .shangpinxiangqing >>> img{
      max-width:100%;
    }
    .goods_item_img {
      width: 100%;
      height: 200px;
      border-radius: 5px 0 0 0px;
      display: block;
      object-fit: cover;
    }
    .lianxikefu{
      padding: 0px;
      height:50px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 15px;
      font-weight: 600;
      color: #fff;
      background: linear-gradient(135deg, #e53e3e, #f56c6c);
      position: relative;
      overflow: hidden;
    }
    .maijiaweixin{
      padding: 0px;
      height:50px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 15px;
      font-weight: 600;
      color: #4f76c7;
      background-color: #ffffff;
      position: relative;
      overflow: hidden;
    }
    .weixin_title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 15px;
      background: #f8fafc;
      border-bottom: 1px solid #eee;
    }
    .weixintupian{
      margin:0 auto;
      width: 180px;
      height: 180px;
      border: 1px solid #eee;
      padding: 5px;
      border-radius: 8px;
      background-color: #fff;
      box-shadow: 0 4px 12px #0000000d;
    }
    .tishiwenzi{
      margin:20px 20px;
      text-align: left;
      font-size: 12px;
      color: #999;
      background-color: #f9f9f9;
      padding: 10px;
      border-radius: 8px;
    }
    .tishiwenzi p{
      height:10px;
    }
  </style>